import api from "../services/api";
import { IPagination } from "../models/IPagination";
import {
  ClashPointsBalanceDTO,
  ClashPointsTransactionDTO,
  AdminClashPointsTransactionDTO,
  AdminAdjustPointsDTO,
} from "../models/IClashPoints";

export const getAllClashPointsTransactions = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  type?: string,
  sortBy?: string,
  sortOrder?: string
): Promise<{
  data: { items: AdminClashPointsTransactionDTO[]; pagination: IPagination; totalAmount?: number };
}> => {
  const params: Record<string, any> = { pageNumber, pageSize };
  if (search) params.search = search;
  if (type) params.type = type;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  return api.get("points/transactions/all", { params });
};

export const getUserPoints = (userId: string): Promise<{ data: ClashPointsBalanceDTO }> =>
  api.get(`points/${userId}`);

export const getUserPointsTransactions = (
  userId: string
): Promise<{ data: ClashPointsTransactionDTO[] }> => api.get(`points/${userId}/transactions`);

export const adjustPoints = (
  dto: AdminAdjustPointsDTO
): Promise<{ data: ClashPointsTransactionDTO }> => api.post("points/adjust", dto);
